import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { NavService } from "../../service/nav.service";
import { AuthService } from "src/app/services/auth.service";
import { ParentService } from "src/app/services/parent.service";
import { FormBuilder } from "@angular/forms";
import { ConfirmModalComponent } from "../confirm-modal/confirm-modal.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  public right_sidebar: boolean = false;
  public open: boolean = false;
  public openNav: boolean = true;
  public isOpenMobile: boolean;
  parentData: any;
  @Output() rightSidebarEvent = new EventEmitter<boolean>();
  parent = "";
  userForm: any;
  childrenData: any;
  constructor(
    public navServices: NavService,
    public auth: AuthService,
    public partentService: ParentService,
    public fb: FormBuilder,
    private modalService: NgbModal
  ) {
    this.userForm = this.fb.group({
      childid: [null],
      deviceid: [null],
    });
    this.userForm.get("childid").valueChanges.subscribe(async (res: any) => {
      if (res) {
        //this.deviceData = null;
        this.childrenData = null;
        this.userForm.get("deviceid").patchValue(null);
        //  this.statgeDoughnut = null;
        this.partentService.getChildData(res).subscribe((childrenData) => {
          this.childrenData = childrenData;
          if (this.childrenData?.device_list && Object.keys(this.childrenData?.device_list).length > 0) {
            this.userForm.patchValue({
              deviceid: Object.keys(this.childrenData?.device_list)[0],
            });
          }
        });
      }
    });
    this.syncSelectedParentChild();

    this.userForm.valueChanges.subscribe((res) => {
      this.partentService.setParentChild(res);
    });
    this.partentService.triggerSelectedParentChildSync.subscribe(() => {
      this.syncSelectedParentChild();
    });
  }
  async ngOnInit() {
    this.partentService.getParentDocData().subscribe((res) => {
      this.parentData = res;
      if (!this.userForm.value.deviceid || !this.userForm.value.childid) {
        if (this.parentData?.child_list && Object.keys(this.parentData?.child_list).length > 0) {
          this.userForm.patchValue({
            childid: Object.keys(this.parentData?.child_list)[0],
          });
        }
      }
    });

  }
  collapseSidebar() {
    this.open = !this.open;
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
  }
  right_side_bar() {
    this.right_sidebar = !this.right_sidebar;
    this.rightSidebarEvent.emit(this.right_sidebar);
  }

  openMobileNav() {
    this.openNav = !this.openNav;
  }
  openConfirm() {
    let message = "Do you want to logout?";
    let title = "Are you sure?";
    const modalRef = this.modalService.open(ConfirmModalComponent, {
      size: "md",
      centered: true,
    });
    modalRef.componentInstance.text = message;
    modalRef.componentInstance.title = title;
    modalRef.result.then(
      (result) => {},
      (reason) => {
        if (reason == "yes") {
          this.auth.logout();
        } else {
        }
      }
    );
  }

  syncSelectedParentChild() {
    if (localStorage.getItem("selectedParentChild")) {
      this.partentService.setParentChild(
        JSON.parse(localStorage.getItem("selectedParentChild"))
      );
      this.userForm.patchValue(
        JSON.parse(localStorage.getItem("selectedParentChild"))
      );
    }
  }
}
